import { session } from "./general";

export const acadReinforcementSessionStorage = {
    acadReinforceId: {
        get: () => Number(session.get("acadReinforceId")),
        set: value => session.set("acadReinforceId", value),
        remove: () => session.remove("acadReinforceId")
    },
    acadReinforceDataToAttendance: {
        get: () => JSON.parse(session.get("acadReinforceDataToAttendance")),
        set: value => session.set("acadReinforceDataToAttendance", JSON.stringify(value)),
        remove: () => session.remove("acadReinforceDataToAttendance")
    },
    isAcadReinforceDraft: {
        get: () => JSON.parse(session.get("isAcadReinforceDraft")),
        set: value => session.set("isAcadReinforceDraft", value)
    },
    currentTabIdxAcadReinforceList: {
        get: () => {
            const value = parseInt(session.get("currentTabIdxAcadReinforceList"));
            return isNaN(value) ? null : value;
        },
        set: value => session.set("currentTabIdxAcadReinforceList", value)
    }
};